import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMap = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0067 20.8433L16.0717 19.2566L7.99837 21.3333L2.31671 19.525C2.08338 19.4433 1.89672 19.2916 1.74506 19.0933C1.60506 18.8949 1.52338 18.6616 1.51171 18.4166V4.26495C1.50004 4.07829 1.535 3.89162 1.61667 3.71662C1.69834 3.54162 1.81506 3.40162 1.96673 3.28496C2.11839 3.16829 2.2934 3.09828 2.48006 3.08661C2.66673 3.06328 2.85336 3.08664 3.02836 3.15664L7.96334 4.74329L16.0367 2.66663L21.6834 4.47495C21.9167 4.55661 22.115 4.70831 22.255 4.90664C22.395 5.10497 22.4884 5.33829 22.5 5.58329V19.7233C22.5117 19.91 22.4767 20.0966 22.4067 20.2599C22.325 20.4349 22.2084 20.575 22.0684 20.6916C21.9167 20.8083 21.7417 20.8783 21.5667 20.9016C21.38 20.925 21.1933 20.9016 21.0183 20.8433H21.0067Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.98657 4.73169V21.2401",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0718 2.76001V19.2684",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMap;
